"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Collapse = _interopRequireDefault(require("./Collapse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Collapse["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/collapse/index.js
// module id = 1337
// module chunks = 0